import { render, staticRenderFns } from "./address-form-overseas.vue?vue&type=template&id=98fcf7ca&scoped=true"
import script from "./address-form-overseas.vue?vue&type=script&lang=js"
export * from "./address-form-overseas.vue?vue&type=script&lang=js"
import style0 from "./address-form-overseas.vue?vue&type=style&index=0&id=98fcf7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fcf7ca",
  null
  
)

export default component.exports